(function () {
  window.addEventListener("load", function () {
    window.wpcc.init({
      border: "thin",
      corners: "small",
      colors: {
        popup: { background: "#F0F2FA", text: "#282D3A", border: "#282D3A" },
        button: { background: "#282D3A", text: "#ffffff" },
      },
      position: "bottom",
      content: {
        message:
          "We use cookies on our platform to give you the most relevant experience by remembering your preferences and repeat visits.",
        button: "Okay",
        link: "Privacy policy",
        href: "/privacy-policy/"
      },
    });
  });
})();
